const ARCHETYPES = {
  contributor: {
    name: "Contributor",
    talentSimpleName: "Individual Contributor",
    id: "CONTRIBUTOR",
    secondaryId: "contributor",
  },
  tech_lead: {
    name: "Tech Lead",
    talentSimpleName: "Technical Lead",
    id: "TECH_LEAD",
    secondaryId: "techlead",
  },
  squad_lead: {
    name: "Squad Lead",
    talentSimpleName: "Manager",
    id: "SQUAD_LEAD",
    secondaryId: "squadlead",
  },
};

const ARCHETYPES_OPTIONS = Object.values(ARCHETYPES).map(({ name, id }) => ({ name, id }));

const TALENT_SIMPLE_ARCHETYPES_OPTIONS = Object.values(ARCHETYPES).map(({ talentSimpleName, id }) => ({
  name: talentSimpleName,
  id,
}));

export default ARCHETYPES;

export { ARCHETYPES_OPTIONS, TALENT_SIMPLE_ARCHETYPES_OPTIONS };
